<template>
  <div>
    <ProfileTypesLoader @loaded="profileTypes = $event" />
    <OAuth2Credentials
      v-if="profileType"
      platform="salesforce"
      :permissions="permissions"
      @update:model-value="credentials = $event"
    />
    <AccountsLoader
      v-if="credentials"
      platform="salesforce"
      :auth="{ type: 'OAUTH', version: '2.0' }"
      :credentials="credentials"
      @loaded="onAccountsLoaded"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ProfileTypesLoader from '@/iam/external/profile-type/ProfileTypesLoader.vue';
import { ProfileType, Account } from '@/iam/external/types';
import OAuth2Credentials from '@/iam/external/auth/credentials/OAuth2Credentials.vue';
import AccountsLoader from '@/iam/external/account/AccountsLoader.vue';
import { Credentials } from '@/iam/external';
import { NewProfile, add } from '.';

interface Data {
  profileTypes: ProfileType[],
  credentials: Credentials|null
}

export default defineComponent({
  emits: ['added'],
  components: { AccountsLoader, OAuth2Credentials, ProfileTypesLoader },
  props: {
    type: {
      type: String,
      required: true,
    },
    accountId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      profileTypes: [],
      credentials: null,
    };
  },
  computed: {
    profileType(): ProfileType|undefined {
      return this.profileTypes.find(pt => pt.type === this.type);
    },
    permissions(): string[] {
      return this.profileType ? this.profileType.permissions : [];
    },
  },
  methods: {
    add(account: Account): void {
      if (!this.profileType || !this.credentials) return;
      const newProfile:NewProfile = {
        externalId: account.id,
        typeId: this.profileType.id,
        accountId: this.accountId,
        description: account.name,
        authType: this.profileType.authType,
        credentials: this.credentials,
        permissions: this.permissions,
      };
      add(newProfile).then((profile) => {
        this.$emit('added', profile);
      });
    },
    onAccountsLoaded(accounts: Account[]) {
      if (accounts.length === 1) {
        this.add(accounts[0]);
      }
    },
  },
});
</script>
